<template>
    <FormulateInput 
        v-if="personalizedType !== 'clipartCategory'" 
        :name="layer.id" :layer="layer" type="imagetoy3d"
        :aspectRatio="aspectRatio" />
</template>

<script>
import { get } from 'lodash';
export default {
    name: "ImageToy3dField",
    props: {
        layer: {
            type: Object,
            required: true
        },
        artwork: {
            type: Object,
            required: true
        },
        personalized: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    computed: {
        personalizedType() {
            return this.layer.personalized.type
        },
        required() {
            return get(this.layer, 'personalized.required', false)
        },
        label() {
            return get(this.layer, 'personalized.label', this.layer.title)
        },
        aspectRatio() {
            const { layer } = this
            return layer.width / layer.height
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Form/ImageToy3dField.vue